import React from 'react';
import { Modal as RNPModal, Portal as RNPPortal } from 'react-native-paper';

import { KeyboardAvoidingView } from '@components/View';

export type ModalProps = React.ComponentProps<typeof RNPModal>;

// TODO: does not properly avoid keyboard
// ref: https://github.com/callstack/react-native-paper/issues/4218
export default function Modal({ children, ...props }: ModalProps) {
  return (
    <RNPPortal>
      <RNPModal {...props}>
        <KeyboardAvoidingView>{children}</KeyboardAvoidingView>
      </RNPModal>
    </RNPPortal>
  );
}
